import React, { createContext, useContext } from 'react';

// set the defaults
const ShoppingListContext = createContext({
	products: {},
	setProducts: () => {},
});

export default ShoppingListContext;
